/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHuman8 = (props: Props) => (
  <Icon viewBox="0 0 8 8" {...props}>
    <path d="M7 5v3H1V5zM4 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" fill="currentcolor" fillRule="evenodd" />
  </Icon>
);
export { SvgHuman8 as Human8 };
